import React from 'react';
import { FormattedDate } from 'react-intl';

import { DATETIME_FORMAT } from 'utils/dateFormats';

type StandardDateTimeProps = Pick<React.ComponentProps<typeof FormattedDate>, 'value'>;

const StandardDateTime: React.FC<StandardDateTimeProps> = ({ value }) => (
  // eslint-disable-next-line no-restricted-syntax
  <FormattedDate value={value} {...DATETIME_FORMAT} />
);

export default StandardDateTime;